import React from "react";
import img1 from "../assets/images/pillar.png";

const pillars = [
  {
    href: "pathyacharya",
    src: "https://images.schooglink.com/image/website/vernacular_content.png",
    alt: "Pathyacharya — हिन्दी में पूरा सिलेबस",
    label: "Pathyacharya",
  },
  {
    href: "kunji",
    src: img1,
    alt: "Kunji AI",
    label: "Kunji AI",
  },
  {
    href: "smart",
    src: "https://images.schooglink.com/image/website/hybrid_technology.png",
    alt: "Hybrid Technology",
    label: "Hybrid Technology",
  },
  {
    href: "assessment",
    src: "https://images.schooglink.com/image/website/assessment.png",
    alt: "Formative & Summative Assessment",
    label: "Formative & Summative Assessment",
  },
];

const Pillars = () => {
  return (
    <section className="mt-12 sm:mt-16 lg:mt-24 w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-center text-2xl sm:text-3xl lg:text-4xl font-extrabold text-gray-900 mb-8 sm:mb-12">
        Our Core Pillars
      </h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 sm:gap-10 place-items-center">
        {pillars.map((pillar, idx) => (
          <a
            href={pillar.href}
            key={idx}
            className="flex flex-col items-center group transition-transform duration-300 hover:scale-105"
          >
            <div className="w-full flex justify-center">
              <img
                src={pillar.src}
                alt={pillar.alt}
                loading="lazy"
                className="w-24 sm:w-32 md:w-40 lg:w-48 object-contain drop-shadow-md transition-transform duration-300 group-hover:scale-110"
              />
            </div>
            <p className="mt-3 text-xs sm:text-sm md:text-base font-semibold text-gray-800 text-center leading-snug">
              {pillar.label}
            </p>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Pillars;
